import { render, staticRenderFns } from "./SimpleCardUi.vue?vue&type=template&id=cbe2c968&lang=pug&"
import script from "./SimpleCardUi.vue?vue&type=script&lang=js&"
export * from "./SimpleCardUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports